import { AxiosResponse } from 'axios';
import http from '../helpers/http-common';
import { IMaterialApoioCleanDTO, IMaterialApoioDTO, IMaterialApoioFullDTO } from '../models/happy-code-api.model';
import { IAxiosResponseCustom } from '../models/http.model';
import { formatHttpParams, Predicate } from '../models/predicate.model';
import { baseCreate } from './base/base-create.service';
import { baseFindById } from './base/base-find-id.service';
import { baseFindList } from './base/base-find-list.service';
import { baseFind } from './base/base-find.service';
import { baseUpdate } from './base/base-update.service';

export const useMaterialApoioService = () => {
	const resourceURL = '/aca-material-apoio';

		const findCustom = (predicate:Predicate): Promise<AxiosResponse<IMaterialApoioDTO[]>> => http.get(`${resourceURL}/custom/find`, formatHttpParams(predicate));


	return {
		...baseFind<IMaterialApoioCleanDTO, IMaterialApoioDTO, IMaterialApoioFullDTO>(resourceURL),
		...baseFindList<IMaterialApoioCleanDTO, IMaterialApoioDTO, IMaterialApoioFullDTO>(resourceURL),
		...baseFindById<IMaterialApoioCleanDTO, IMaterialApoioDTO, IMaterialApoioFullDTO>(resourceURL),
		...baseCreate<IMaterialApoioCleanDTO, IMaterialApoioDTO, IMaterialApoioFullDTO>(resourceURL),
		...baseUpdate<IMaterialApoioCleanDTO, IMaterialApoioDTO, IMaterialApoioFullDTO>(resourceURL),
		patch: (toUpdate: any): Promise<IAxiosResponseCustom<IMaterialApoioCleanDTO>> => http.patch(`${resourceURL}/${toUpdate.id}`, toUpdate),
		patchFull: (toUpdate: any): Promise<IAxiosResponseCustom<IMaterialApoioCleanDTO>> => http.patch(`${resourceURL}/full/${toUpdate.id}`, toUpdate),
		findCustom
	};
};
